export default __webpack_public_path__ + "static/newsListSpotlightClip-ea5dffa88b4956a348764d7a088a46fe.png";